import React, { useState, useEffect } from "react";
import EmojiDaysActivityGraph from "./EmojiDaysActivityGraph";

export default function EmojiScoreHistory({ game }) {
  const [loading, setLoading] = useState(true);
  const [showGraph, setShowGraph] = useState(false);

  const history = game.streakHistory || [];

  useEffect(() => {
    if (!game?.loadHistory) return;

    setLoading(true);
    game.loadHistory()
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [game?.loadHistory]);

  return (
    <div className="min-h-screen mt-8 bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white flex flex-col">
      <div className="sticky top-0 z-20 flex items-center justify-between px-3 py-3 border-b border-cyan-500/20 bg-slate-950/90 backdrop-blur">
        <button
          onClick={() => game.setScreen("home")}
          className="text-cyan-300 hover:text-cyan-100 w-fit px-2 py-1 text-xs lg:text-sm"
        >
          ← Back
        </button>

        <div className="text-center">
          <div className="font-black text-cyan-300">📜 WonderEmoji History</div>
          <div className="text-xs text-slate-400 mt-1">
            {history.length} Total Plays
          </div>
        </div>

        <button
          onClick={() => setShowGraph(!showGraph)}
          className={`w-fit px-2 py-1 rounded-xl text-xs font-bold transition ${
            showGraph 
              ? "bg-cyan-500 text-black" 
              : "bg-cyan-500/20 text-cyan-300 hover:bg-cyan-500/30"
          }`}
        >
          {showGraph ? "Hide" : "Show"} 📊 Graph
        </button>
      </div>

      {showGraph && (
        <div className="p-3 border-b border-slate-700">
          <EmojiDaysActivityGraph history={history} />
        </div>
      )}

      <div className="flex-1 overflow-y-auto p-3 space-y-3">
        {loading ? (
          <div className="text-center py-12">Loading history...</div>
        ) : history.length === 0 ? (
          <div className="mt-24 flex flex-col items-center justify-center text-center">
            <div className="text-6xl opacity-50">🪹</div>
            <div className="mt-4 text-slate-400">No Play yet.</div>
            <div className="text-sm text-slate-500 mt-1">Start playing to build your history!</div>
          </div>
        ) : (
          history.map((item, index) => {
            const date = new Date(item.confirmedAt || item.createdAt);
            return (
              <div key={item._id || index} className="rounded-2xl bg-slate-900 border border-slate-700 p-4">
                {/* your existing card content */}
                <div className="flex justify-between items-start mb-3">
                  <div className="text-xs text-slate-400">#{history.length - index}</div>
                  <div className="flex gap-2">
                    <div className="text-[10px] bg-slate-800 px-2 py-1 rounded-full text-slate-300">
                      {date.toLocaleDateString("en-GB")}
                    </div>
                    <div className="text-[10px] bg-slate-800 px-2 py-1 rounded-full text-slate-300">
                      {date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-2 text-sm">
                  <div className="rounded-xl bg-slate-800/60 px-2 py-2 text-center">
                    <div className="text-emerald-400 font-black">{item.score ?? 0}</div>
                    <div className="text-[10px] text-slate-400">Points</div>
                  </div>
                  <div className="rounded-xl bg-slate-800/60 px-2 py-2 text-center">
                    <div className="text-cyan-300 font-black">{item.accuracy ?? 0}%</div>
                    <div className="text-[10px] text-slate-400">Accuracy</div>
                  </div>
                  <div className="rounded-xl bg-slate-800/60 px-2 py-2 text-center">
                    <div className="text-violet-300 font-black">{item.gridSize}x{item.gridSize}</div>
                    <div className="text-[10px] text-slate-400 capitalize">{item.category}</div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}